import {
  AdFoxBanner,
  calculatedParamsMiddleware,
  fetchTargets,
  IAdFoxBannerContext,
  mergeMiddlewares,
} from '@cian/adfox';
import * as React from 'react';
import { IAdfoxConstants } from './constants';

const SECTION_TYPES: {[section: string]: number} = {
  index: 1,
  sale: 2,
  rent: 3,
  'daily-rent': 4,
  commercial: 5,
  'new-buildings': 6,
};

const adfoxMiddleware = (constants: IAdfoxConstants, section: string = 'index') => {
  return mergeMiddlewares(
    calculatedParamsMiddleware(),
    fetchTargets('apps', {
      baseUrl: `//${window.__mainpage_api_host__ || window.location.host}/`,
      section_type: SECTION_TYPES[section] || 1,
    }),
    Promise.resolve(constants),
  );
};

interface IProps {
  banner: (context: IAdFoxBannerContext) => React.ReactElement<any>;
  failureBanner?: (error: Error) => React.ReactElement<any>;
  constants: IAdfoxConstants;
  section?: string;
}

export const Adfox = (props: IProps) => {
  // компонент AdFoxBanner может вернуть null,
  // что пораждает ошибку типизации. Попытка поднять версии реакта и тайпскрипта
  // до версии в либе @cian/adfox не увенчалась успехом, и ошибка продолжала
  // воспроизводиться. Таким образом, вот такой хак.
  // tslint:disable-next-line:no-any
  const AnyComponent = AdFoxBanner as any;

  return(
    <AnyComponent
      middleware={() => adfoxMiddleware(props.constants, props.section)}
      renderFetched={props.banner}
      renderFailure={props.failureBanner}>
    </AnyComponent>
  );
};
